import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';

const ComplementoPlanesderetiroResumen = ({ data = [], onEdit, onListChange }) => {

  const { AportacionesODepositos = [] } = data;

  // const handleEdit = (item) => {
  //   onEdit(item);
  // }

  // const handleDelete = (item) => {
  //   const newData = data.filter((value) => item.id !== value.id);

  //   onListChange(newData);
  // }

  const AportacionesODepositosList =() => {
    const listItems = AportacionesODepositos.map((aportaciones, index) =>
      <ListGroup.Item key={ index }>
          <strong className="text-info card-label-info">Tipo de aportación o depósito: </strong>
          { aportaciones.TipoAportacionODeposito }
          <br/>
          <strong className="text-info card-label-info">Monto aportación o depósito: </strong>
          { aportaciones.MontAportODep }
          <br/>
          <strong className="text-info card-label-info">RFC Fiduciaria: </strong>
          { aportaciones.RFCFiduciaria }
          <br/>
        </ListGroup.Item>
    );

    return (
      <ListGroup variant="flush">
        <strong className="text-dark card-label-dark"> Aportaciones o depósitos </strong>
        { listItems }
      </ListGroup>
    );
  }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">Planes de Retiro, Versión { data.Version }</Card.Subtitle>
        <br/>

        <strong className="text-info card-label-info">Sistema Financiero: </strong>
        { data.SistemaFinanc }
        <br/>

        <strong className="text-info card-label-info">Monto total aportaciones (Año anterior): </strong>
        { data.MontTotAportAnioInmAnterior }
        <br/>

        <strong className="text-info card-label-info">Monto intereses reales(Año anterior): </strong>
        { data.MontIntRealesDevengAniooInmAnt }
        <br/>

        <strong className="text-info card-label-info">Hubo retiros: </strong>
        { data.HuboRetirosAnioInmAntPer }
        <br/>

        <strong className="text-info card-label-info">Monto total retirado: </strong>
        { data.MontTotRetiradoAnioInmAntPer }
        <br/>

        <strong className="text-info card-label-info">Monto total exento retirado: </strong>
        { data.MontTotExentRetiradoAnioInmAnt }
        <br/>

        <strong className="text-info card-label-info">Monto total exedente: </strong>
        { data.MontTotExedenteAnioInmAnt }
        <br/>

        <strong className="text-info card-label-info">Retiros en el ejercicio inmediato anterior: </strong>
        { data.HuboRetirosAnioInmAnt }
        <br/>

        <strong className="text-info card-label-info">Monto total retiros ejercicio inmediato anterior: </strong>
        { data.MontTotRetiradoAnioInmAnt }
        <br/>

        <strong className="text-info card-label-info">Número de referencia: </strong>
        { data.NumReferencia }
        <br/>
        <br/>

        { AportacionesODepositosList() }

      </Card.Body>
    </Card>
  )
}

export default ComplementoPlanesderetiroResumen
